import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

function Logo({ logoType, page }) {
    if (logoType === 'HorizontalLogoWhite') {
        return (
            <StaticImage 
                src="../images/horizontal-logo-white.png" 
                alt="Holborn Assets logo" 
                width={250}
                height={37}
                formats={["auto", "webp"]} // Exclude `avif` format for this specific image
            />
        )
    } else if (logoType === 'Holborn25Footer') {
        if (page === 'Navbar') {
            return (
                <StaticImage 
                    src="../images/holborn-25-footer.png" 
                    alt="Holborn Assets logo" 
                    width={80}
                    formats={["auto", "webp"]}
                />
            )
        } else {
            return (
                <StaticImage 
                    src="../images/holborn-25-footer.png" 
                    alt="Holborn Assets logo" 
                    width={250}
                    formats={["auto", "webp"]}
                />
            )
        }
    } else {
        return (
            <StaticImage 
                src="../images/holborn-logo-hz.png" 
                alt="Holborn Assets logo" 
                width={208}
                height={37}
                formats={["auto", "webp"]}
            />
        )
    }
}

export default Logo;